import Events from './Events';
import AppData from './AppData';
import Lesson from './Lesson';
import Repertoire from './Repertoire';

import { all } from "redux-saga/effects";


export default function* rootSaga() {
  yield all([
    ...Events,
    ...AppData,
    ...Lesson,
    ...Repertoire
  ])
}
